import React, { useEffect, useState } from "react";
import { ContentContainer } from "../../../components/layout";
import {
  Button,
  DateRangePicker,
  LinearProgressBar,
  Modal,
  MultiSelect,
  NoDataFoundTemplate,
  Select,
  Table,
} from "../../../components/core";
import { BarCharts } from "../../../components/charts";
import { useApolloClient, useLazyQuery, useQuery } from "@apollo/client";
import {
  LOCKER_LIST_FOR_PEAK_HOURS,
  LOCKER_OCCUPANCY_PEAK_HOURS,
} from "../../../constants/graphql/peak-reports-queries";
import { Label } from "recharts";
import {
  CustomValueFormatter,
  convertTo12HourFormat,
  customLabelFormatter,
} from "../../../algorithms/timeformat";
import { formatDate, formatDateYYYYMMDD } from "../../../algorithms/date";
import { useDispatch, useSelector } from "react-redux";
import { setTotalDoors } from "../../../features/peak-hours-report/peak-hours-report-slice";
import PrimereactDateRange from "../../../components/core/date-range-primereact";
import { QUERY_LOCKER_TYPE } from "../../../constants/graphql/drop-off-graphql";
import { NEWEST_LOCKER_NAME_QUERY } from "../../../features/stay-time-in-locker/stay-time-query/stay-time-graphql";
import { Card } from "primereact/card";
import { Strings } from "../../../constants/strings";
function convertArrayToEpoch(array) {
  return array.map((obj) => {
    const [hours, period] = obj.hour.match(/\d+|[APMapm]{2}/g);
    const adjustedHours =
      period.toLowerCase() === "pm" && hours !== "12"
        ? +hours + 12
        : +hours % 12;
    const epochTime = new Date().setHours(adjustedHours, 0, 0, 0);

    return { ...obj, hour: epochTime };
  });
}
export default function PeakHoursReportPage() {
  const client = useApolloClient();
  const operatorId = JSON.parse(localStorage.getItem("user")).operator_id;
  const dispatch = useDispatch();
  const totalDoors = useSelector((state) => state.peakHoursReport.totalDoors);
  // local states
  const [header, setHeader] = React.useState("");
  const [doorNumbers, setDoorNumbers] = React.useState({
    small: 0,
    medium: 0,
    large: 0,
    xl: 0,
  });
  const maxDate = (() => {
    const d = new Date();
    d.setMonth(d.getMonth() - 6);
    return d;
  })();

  const [loadingData, setLoadingData] = React.useState(false);
  const [noData, setNoData] = React.useState(false);
  const [searchData, setSearchData] = React.useState([]);
  const [validation, setValidation] = React.useState({
    icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
    title: "",
    message: "",
    open: false,
  });
  const [lockerData, setLocketData] = React.useState([]);
  const [searchVariables, setSearchVariables] = React.useState({
    operatorId: operatorId,
    dateStart: maxDate,
    dateEnd: new Date(),
    lockers: [],
    lockerTypeId: "-1",
  });
  const [allLockersSelected, setAllLockersSelected] = useState(false);

  // gql
  const [lockerOccupancyPeakHours] = useLazyQuery(LOCKER_OCCUPANCY_PEAK_HOURS, {
    fetchPolicy: "no-cache",
  });
  const fetchLockerType = useQuery(QUERY_LOCKER_TYPE);

  //   const lockerList = useQuery(LOCKER_LIST_FOR_PEAK_HOURS, {
  //     variables: {
  //       operatorId: localStorage.getItem("user")
  //         ? JSON.parse(localStorage.getItem("user")).operator_id
  //         : "",
  //     },
  //   });

  const [fetchLockerName, { data: lockerNameData }] = useLazyQuery(
    NEWEST_LOCKER_NAME_QUERY,
    {
      variables: {
        operatorId: operatorId,
        //   selectedLockerType: selectedLockerType,
      },
    }
  );
  // handle changes
  const handleChange = (event) => {
    const { name, value } = event.target;

    if (name === "lockers") {
      let tempLockers = [];
      value.forEach((element) => {
        tempLockers.push(element.value);
      });
      console.log(tempLockers);
      setSearchVariables((prev) => ({ ...prev, [name]: tempLockers }));
    } else {
      setSearchVariables((prev) => ({ ...prev, [name]: value }));
    }
  };

  const validateSearchVars = () => {
    if (
      searchVariables.lockerTypeId !== "-1" &&
      searchVariables.lockers.length === 0
    ) {
      setSearchData([]);
      setValidation({
        icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
        title: Strings.popup_error_title_search_criteria,
        message: Strings.popup_error_lockername,
        open: true,
        actions: (
          <div className="w-full">
            <Button
              onClick={() => setValidation({ open: false })}
              value={"OK"}
              className={"p-2 w-full"}
            />
          </div>
        ),
      });
    } else {
      handleSearch();
    }
  };

  const handleSearch = async () => {
    const start = formatDateYYYYMMDD(searchVariables.dateStart);
    const end = formatDateYYYYMMDD(searchVariables.dateEnd);
    try {
      let doorsList = {
        small: 0,
        medium: 0,
        large: 0,
        xl: 0,
      };
      headerValue();
      setLoadingData(true);
      let tempSearchVar = { ...searchVariables };

      tempSearchVar.dateStart = start;
      tempSearchVar.dateEnd = end;

      if (searchVariables.lockers && searchVariables.lockers.length > 0) {
        tempSearchVar.lockers = searchVariables.lockers.map(
          (locker) => locker.value
        );
      } else {
        delete tempSearchVar.lockers;
      }

      const { data } = await client.query({
        query: LOCKER_OCCUPANCY_PEAK_HOURS,
        variables: tempSearchVar,
      });
      let tempData = [];
      data.lockerOccupancyPeakHours[0].doorSizes.forEach((element) => {
        console.log(element);
        switch (element.size) {
          case "Small":
            doorsList.small = element.doors;
            break;
          case "Medium":
            doorsList.medium = element.doors;
            break;
          case "Large":
            doorsList.large = element.doors;
            break;
          case "XL":
            doorsList.xl = element.doors;
            break;
          default:
            break;
        }
      });
      // doorsList.medium = doorsList.small =
      // 	data.lockerOccupancyPeakHours[0].doorSizes[0].doors;
      // doorsList.large = doorsList.small =
      // 	data.lockerOccupancyPeakHours[0].doorSizes[0].doors;
      // doorsList.xl = doorsList.small =
      // 	data.lockerOccupancyPeakHours[0].doorSizes[0].doors;

      data.lockerOccupancyPeakHours.forEach((element) => {
        let tempElement = {
          hour: convertTo12HourFormat(element.hour),
          Large: 0,
          Small: 0,
          XL: 0,
          Medium: 0,
        };
        element.doorSizes.forEach((doorElement) => {
          switch (doorElement.size) {
            case "Small":
              tempElement.Small = parseFloat(
                doorElement.avgOccupancyRate * 100
              ).toFixed(2);
              break;
            case "Medium":
              tempElement.Medium = parseFloat(
                doorElement.avgOccupancyRate * 100
              ).toFixed(2);
              break;
            case "Large":
              tempElement.Large = parseFloat(
                doorElement.avgOccupancyRate * 100
              ).toFixed(2);
              break;
            case "XL":
              tempElement.XL = parseFloat(
                doorElement.avgOccupancyRate * 100
              ).toFixed(2);
              break;
            default:
              break;
          }
        });
        tempData.push(tempElement);
      });

      setSearchData(tempData);

      setSearchVariables({
        ...searchVariables,
        dateEnd: searchVariables.dateEnd,
        dateStart: searchVariables.dateStart,
      });
      setLoadingData(false);
      setNoData(tempData.length === 0);
      setDoorNumbers(doorsList);
      dispatch(setTotalDoors(doorsList));
    } catch (error) {
      console.log(error);
    }
  };

  const [lockerType, setLockerType] = useState();
  useEffect(() => {
    if (fetchLockerType.data) {
      let tempData = [];
      fetchLockerType.data.lockerTypes.forEach((element, index) => {
        tempData.push({
          value: element.lockerTypeId,
          name: element.lockerType,
        });
      });
      setLockerType(tempData);
    }
  }, [fetchLockerType.data]);
  // use effects
  useEffect(() => {
    if (searchVariables.lockerTypeId !== "-1") {
      fetchLockerName({
        variables: {
          operatorId: operatorId,
          lockerTypeId: searchVariables.lockerTypeId,
        },
      });
    }
  }, [searchVariables.lockerTypeId, operatorId]);

  useEffect(() => {
    if (lockerNameData) {
      const tempData = lockerNameData.lockerInfo.map((element) => ({
        label: element.lockerName,
        value: element.lockerId,
      }));

      if (!allLockersSelected) {
        tempData.unshift({
          value: 0,
          label: "All Lockers",
        });
      }

      setLocketData(tempData);
    }
  }, [lockerNameData, allLockersSelected]);

  useEffect(() => {
    const selected = searchVariables.lockers;
    const allLockers = lockerData;

    const hasZeroValue = selected.some((item) => item.value === 0);

    if (hasZeroValue) {
      setAllLockersSelected(true);
    } else if (selected.length === 0) {
      setAllLockersSelected(false);
    } else if (selected.length !== allLockers.length) {
      setAllLockersSelected(false);
    } else {
      setAllLockersSelected(true);
    }
  }, [searchVariables.lockers, lockerData]);

  useEffect(() => {
    if (allLockersSelected) {
      const selectedLockers = lockerData.filter((locker) => locker.value !== 0);

      setSearchVariables({
        ...searchVariables,
        lockers: selectedLockers,
      });
    }
  }, [allLockersSelected, lockerData]);

  console.log({ searchVariables });
  const headerValue = () => {
    setHeader({
      title: "LOCKER OCCUPANCY PEAK HOURS REPORT",
      details: ` for ${
        searchVariables.lockers && searchVariables.lockers.length > 0
          ? searchVariables.lockers
              .map((data) => lockerData.find((x) => x.value === data))
              .filter(Boolean) // Filter out undefined values
              .map((locker) => locker.label)
              .join(", ")
          : "ALL Lockers"
      } from ${formatDate(searchVariables.dateStart)} to ${formatDate(
        searchVariables.dateEnd
      )}`,
    });
  };
  const customLegendFormatter = (value) => {
    let stringVal = "";
    switch (value) {
      case "Small":
        stringVal = `${value} - ${doorNumbers.small}`;
        break;
      case "Medium":
        stringVal = `${value} - ${doorNumbers.medium}`;
        break;
      case "Large":
        stringVal = `${value} - ${doorNumbers.large}`;
        break;
      case "XL":
        stringVal = `${value} - ${doorNumbers.xl}`;
        break;
      default:
        break;
    }
    return stringVal; // Custom formatting for legend items
  };
  const CustomLegendContent = (value) => {
    return (
      <div>
        {/* Your custom legend content */}
        <p className="font-bold">Total Doors</p>
        {value.payload.map((element) => {
          return (
            <div className="flex gap-2">
              {element.dataKey === "XL" &&
              (doorNumbers.xl === 0 || doorNumbers.xl === "0") ? (
                ""
              ) : (
                <div
                  className="my-auto"
                  style={{
                    width: 12,
                    height: 12,
                    backgroundColor: element.color,
                  }}
                ></div>
              )}

              <p
                style={{
                  color: element.color,
                }}
              >
                {element.dataKey === "XL" &&
                (doorNumbers.xl === 0 || doorNumbers.xl === "0")
                  ? ""
                  : `${element.dataKey} - `}{" "}
              </p>
              <p style={{ color: element.color }}>
                {element.dataKey === "Small" && <p>{doorNumbers.small}</p>}
                {element.dataKey === "Medium" && <p>{doorNumbers.medium}</p>}
                {element.dataKey === "Large" && <p>{doorNumbers.large}</p>}
                {element.dataKey === "XL" && (
                  <p>
                    {doorNumbers.xl === 0 || doorNumbers.xl === "0"
                      ? ""
                      : doorNumbers.xl}
                  </p>
                )}
              </p>
            </div>
          );
        })}
      </div>
    );
  };

  const handleFilterChange = (e, field) => {
    let value = e.target.value;
    if (field === "startDate" || field === "endDate") {
      value = value ? new Date(value) : null;
    }

    if (field === "lockerTypeId") {
      setSearchVariables({
        ...searchVariables,
        [field]: value,
        lockers: [],
      });
    } else {
      setSearchVariables({
        ...searchVariables,
        [field]: value,
      });
    }
  };

  return (
    <ContentContainer containerTitle={"Locker Occupancy Peak Hours Report"}>
      <h2 className={"font-bold"}>Locker:</h2>
      <div className={"grid grid-cols-6 w-full gap-y-2"}>
        <p className="col-span-1">Locker Type:</p>
        <Select
          items={lockerType}
          className={"col-span-3"}
          value={searchVariables.lockerTypeId}
          defaultOption={{ value: "-1", name: "-- ALL--" }}
          onChange={(event) => {
            handleFilterChange(event, "lockerTypeId");
          }}
        />
        <div className="col-span-2"></div>

        <p className="col-span-1">Locker Name:</p>
        <MultiSelect
          className={"col-span-3"}
          items={lockerData}
          value={searchVariables.lockers}
          placeholder={`${
            searchVariables.lockerTypeId === "-1" ? "ALL Lockers" : "Select..."
          }`}
          disabled={searchVariables.lockerTypeId === "-1"}
          onChange={(event) => {
            handleFilterChange(event, "lockers");
          }}
        />
      </div>

      <p className="font-bold">Date range:</p>
      {/* <DateRangePicker
				className={"w-1/2 mb-2"}
				onChange={handleChange}
				startDateName="dateStart"
				endDateName="dateEnd"
				startDate={searchVariables.dateStart}
				endDate={searchVariables.dateEnd}
			/> */}

      <PrimereactDateRange
        className={"w-1/2 mb-2"}
        onChange={handleChange}
        startDateName="dateStart"
        readOnlyInput={true}
        endDateName="dateEnd"
        max={new Date()} // Today's date as the maximum
        min={new Date("2021-01-01")} // Jan 1, 2021, as the minimum
        startDate={searchVariables.dateStart}
        endDate={searchVariables.dateEnd}
      />

      <div className="grid grid-cols-2 w-1/2 gap-y-2">
        <div></div>
        <u
          className="flex hover:text-blue-500 cursor-pointer mt-4 ml-auto w-min"
          onClick={() => {
            setSearchVariables({
              ...searchVariables,
              startDate: maxDate,
              endDate: new Date(),
              lockers: [],
              lockerTypeId: "-1",
            });
          }}
        >
          <i className="fas fa-undo my-auto"></i>
          <p className="ml-1">Reset</p>
        </u>
      </div>

      <Button
        className={"p-2 mb-4"}
        value={"Search"}
        onClick={validateSearchVars}
      />
      <LinearProgressBar label="" open={loadingData} />
      {noData && <NoDataFoundTemplate width={56} height={56} />}
      {noData === false && searchData.length > 0 && (
        <div className="px-4">
          <Card>
            <BarCharts
              xAxisBar={[
                { dataKey: "Small", fill: "#8884d8" },
                { dataKey: "Medium", fill: "#82ca9d" },
                { dataKey: "Large", fill: "#3e3e3e" },
                // { dataKey: "XL", fill: "#FECD08" },
              ]}
              dataKey="hour"
              data={searchData}
              legendLayout="vertical"
              legendVerticalAlign="top"
              xAxislabel={<Label value="" offset={0} position="insideBottom" />}
              yAxisLabel={{
                value: "Average Occupancy Rate",
                angle: -90,
                position: "insideLeft",
              }}
              yAxisDomain={[0, 100]}
              customTooltipLabelFormatter={customLabelFormatter}
              customTooltopValueFormatter={CustomValueFormatter}
              customLegendLayoutFormatter={customLegendFormatter}
              customLegendContentFormatter={CustomLegendContent}
              header={header}
            />
            <div className="bg-primary-primaryYellow text-center mt-14">
              <p className="font-bold text-xl">{header.title}</p>
              <p className="font-bold">{header.details}</p>
            </div>
            <Table
              headers={[
                { header_key: "hour", header_name: "Hours", tag: "timeSpan" },
                {
                  header_key: "Small",
                  header_name: "Small",
                  tag: "percent",
                  total: totalDoors.small,
                },
                {
                  header_key: "Medium",
                  header_name: "Medium",
                  tag: "percent",
                  total: totalDoors.medium,
                },
                {
                  header_key: "Large",
                  header_name: "Large",
                  tag: "percent",
                  total: totalDoors.large,
                },
              ]}
              items={convertArrayToEpoch(searchData)}
            />
          </Card>
        </div>
      )}

      <Modal
        icon={validation.icon}
        title={validation.title}
        message={validation.message}
        open={validation.open}
        actions={validation.actions}
      />
    </ContentContainer>
  );
}
